export default "__VITE_ASSET__DroDv8p7__"